var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "type"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 3.0006V14.9994M3.0006 5.25038V3.75053C3.0006 3.55163 3.07961 3.36089 3.22025 3.22025C3.36089 3.07961 3.55163 3.0006 3.75053 3.0006H14.2495C14.4484 3.0006 14.6391 3.07961 14.7798 3.22025C14.9204 3.36089 14.9994 3.55163 14.9994 3.75053V5.25038M6.75023 14.9994H11.2498",
    stroke: "#6B7280",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarPaperclip);
export default __webpack_public_path__ + "static/media/toolbar-paperclip.92db23b80da124803daf16ce2fb3cb1d.svg";
export { ForwardRef as ReactComponent };